import { useEffect, useMemo, useState } from 'react'

import { useAuth } from '../lib/auth'
import { useCustomerId } from './useCustomerId'

/** @deprecated use useCamelLazyQuery, useCamelMutation, or useCamelQuery */
const useCamelGraphQl = (resourceCall, variables) => {
  const { getAccessTokenSilently } = useAuth()
  const customerId = useCustomerId()
  const [error, setError] = useState(null)

  // memoize variables with default value to prevent infinite loop
  const resourceCallVariables = useMemo(() => variables || {}, [variables])

  useEffect(() => {
    ;(async () => {
      try {
        const accessToken = await getAccessTokenSilently()
        resourceCall({
          variables: {
            customerId,
            ...resourceCallVariables,
          },
          context: {
            uri: process.env.GATSBY_CAMEL_URL,
            token: accessToken,
          },
        })
        setError(null)
      } catch (accessTokenError) {
        setError(accessTokenError)
      }
    })()
  }, [customerId, getAccessTokenSilently, resourceCall, resourceCallVariables])

  return error
}

export default useCamelGraphQl
